import { useContext } from 'react';
import {
    ActionDependant,
    GlobalDataContext,
    propsDataLocationToPathAndValue,
    TemplateContext,
} from '@ea-lab/reactive-json';
import { PictoPicker } from './PictoPicker';

/**
 * PictoPickerField — l'enveloppe reactive-json de `PictoPicker` : le choix du
 * picto d'une entité dans un formulaire YAML.
 *
 * Tout le comportement (bibliothèque d'icônes, rendu de la valeur héritée) vit
 * dans `PictoPicker`, partagé avec les formulaires React (ceux du wiki) ; il ne
 * reste ici que la liaison au magasin.
 *
 * Props :
 *   dataLocation – liaison reactive-json (stocke le nom Lucide, ex. « Rocket »)
 *   label        – intitulé rappelé dans le libellé accessible du bouton
 *   readOnly     – désactive l'ouverture de la bibliothèque (défaut : false)
 */
export const PictoPickerField = ({ props, datafield, path }) => {
    const globalDataContext = useContext(GlobalDataContext);
    const templateContext = useContext(TemplateContext);

    const { formData, formDataPath } = propsDataLocationToPathAndValue({
        currentPath: path,
        datafield,
        dataLocation: props.dataLocation,
        defaultValue: '',
        globalDataContext,
        templateContext,
    });

    const readOnly = props.readOnly ?? false;

    return (
        <ActionDependant {...props}>
            <PictoPicker
                value={typeof formData === 'string' ? formData : ''}
                onChange={(name) => globalDataContext?.updateData?.(name, formDataPath)}
                label={props.label ?? 'le picto'}
                readOnly={readOnly}
            />
        </ActionDependant>
    );
};

export default PictoPickerField;
